import { render, staticRenderFns } from "./ElementNameTableColumn.vue?vue&type=template&id=60348238"
import script from "./ElementNameTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementNameTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports